/**
 * description:
 * Masonry grid of event photo cards. To add a new album, add an entry
 * (name + Google Drive link) through the events API — no new component needed.
 */
import { Masonry } from "@mui/lab";
import GalleryComponent from "./GalleryComponent";

const GalleryLayout = ({ events }) => (
  <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={3}>
    {events.map((item, i) => (
      <GalleryComponent key={item.link ?? i} event={item.name} link={item.link} />
    ))}
  </Masonry>
);

export default GalleryLayout;
